export default "__VITE_ASSET__zo8pkSO9__"